export const ROLES = [
    { id: 'national_head', label: 'National Head', level: 1 },
    { id: 'zone_head', label: 'Zone Head', level: 2 },
    { id: 'state_head', label: 'State Head', level: 3 },
    { id: 'middle_manager', label: 'Team Leader', level: 4 },
    { id: 'manager', label: 'Frontline', level: 5 }
];

const ALLOWED_EMAIL_DOMAINS = [
    'gmail.com',
    'yahoo.com',
    'outlook.com',
    'hotmail.com',
    'icloud.com',
    'zoho.com',
    'acemoney.in',
    'acemoney.com'
];

export const VALIDATORS = {
    name: (v) => (/^[A-Za-z\s]+$/.test(v) && v.trim().length > 1 ? '' : 'Name must contain only letters (min 2 chars)'),
    employeeId: (v) => (v ? '' : 'Employee ID is required'),
    email: (v) => {
        if (!v) return 'Email is required';
        const emailRegex = /^[a-zA-Z0-9._%+-]+@([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
        const match = v.match(emailRegex);
        if (!match) return 'Enter a valid email address';
        const domain = match[1].toLowerCase();
        if (!ALLOWED_EMAIL_DOMAINS.includes(domain)) {
            return `Only valid domains like gmail.com, yahoo.com, etc. are allowed`;
        }
        return '';
    },
    phone: (v) => (/^\d{10}$/.test(v) ? '' : 'Enter a valid 10-digit phone number'),
    pancard: (v) => (/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(v) ? '' : 'Enter a valid PAN (e.g. ABCDE1234F)'),
    aadharNumber: (v) => (/^\d{12}$/.test(v) ? '' : 'Enter a valid 12-digit Aadhaar number'),
    state: (v) => (v ? '' : 'Please select a state'),
    district: (v) => (v ? '' : 'Please select a district'),
    city: (v) => (v ? '' : 'Please select a city'),
    customCity: () => '',
    role: (v) => (v ? '' : 'Please select a role'),
    bgvStatus: (v) => (v ? '' : 'Please select BGV status'),
    trainingStatus: (v) => (v ? '' : 'Please select training status'),
    zone: (v) => (v ? '' : 'Please select a zone'),
    designation: (v) => (v ? '' : 'Please select a designation'),
    bankAccountNumber: (v) => (!v || /^\d{9,18}$/.test(v) ? '' : 'Enter a valid bank account number (9-18 digits)'),
    bankIfscCode: (v) => (!v || /^[A-Z]{4}0[A-Z0-9]{6}$/.test(v) ? '' : 'Enter a valid IFSC code (e.g. SBIN0001234)'),
    bankName: () => '',
    businessSegments: (v) => (v && v.length > 0 ? '' : 'Please select at least one business segment')
};

export const INITIAL_FORM = {
    name: '',
    employeeId: '',
    email: '',
    phone: '',
    pancard: '',
    aadharNumber: '',
    bankAccountNumber: '',
    bankIfscCode: '',
    bankName: '',
    state: '',
    district: '',
    city: '',
    customCity: '',
    role: '',
    l1Lead: '',
    dateOfOffer: '',
    dateOfJoining: '',
    bgvStatus: '',
    trainingStatus: '',
    zone: '',
    designation: '',
    effectiveDate: '',
    photograph: null,
    photographName: '',
    photographPreview: null,
    poaImage: null,
    poaImageName: '',
    poaImagePreview: null,
    // New fields
    offerLetter: null,
    offerLetterName: '',
    offerLetterPreview: null,
    empAgreement: null,
    empAgreementName: '',
    empAgreementPreview: null,
    nda: null,
    ndaName: '',
    ndaPreview: null,
    proforma: null,
    proformaName: '',
    proformaPreview: null,
    aadhar: null,
    aadharName: '',
    aadharPreview: null,
    bankDetails: null,
    bankDetailsName: '',
    bankDetailsPreview: null,
    eduCertificate: null,
    eduCertificateName: '',
    eduCertificatePreview: null,
    expLetter: null,
    expLetterName: '',
    expLetterPreview: null,
    salarySlip: null,
    salarySlipName: '',
    salarySlipPreview: null,
    cv: null,
    cvName: '',
    cvPreview: null,
    cif: null,
    cifName: '',
    cifPreview: null,
    // BGV Enhancement fields
    bgvRemark: '',
    bgvDocument: null,
    bgvDocumentName: '',
    bgvDocumentPreview: null,
    businessSegments: []
};
